import React from "react";
import { createBrowserRouter } from "react-router-dom";
import Dashboard from "./routes/Dashboard";
import Login from "./routes/Login";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./routes/Layout";
import CardsRoute from "./routes/Cards";

const router = createBrowserRouter([
    {
        path: "/",
        element: <Layout />,
        children: [
            {
                path: "/",
                element: (
                    <ProtectedRoute>
                        <Dashboard />
                    </ProtectedRoute>
                ),
            },
            {
                path: "/cards",
                element: (
                    <ProtectedRoute>
                        <CardsRoute />
                    </ProtectedRoute>
                ),
            },
            {
                path: "/login",
                element: <Login />,
            },
        ],
    },
]);

export default router;
